import {Component, input, OnChanges} from '@angular/core'
import {NgxEchartsDirective, provideEchartsCore} from 'ngx-echarts'
import * as echarts from 'echarts/core'
import {EChartsType} from 'echarts/core'
import {PieChart} from 'echarts/charts'
import {GridComponent, TooltipComponent} from 'echarts/components'
import {CanvasRenderer} from 'echarts/renderers'

// @ts-expect-error Does not work atm. Looking into it.
import lang from 'echarts/lib/i18n/langFR.js'
import {EChartsOption} from 'echarts'
import {KalpResult} from '../../../model/kalp-result'
import {PrintableChartComponent} from '../../../common/printable-chart/printable-chart.component'


echarts.use([PieChart, TooltipComponent,
  GridComponent, CanvasRenderer])
echarts.registerLocale('SV', lang)

@Component({
  selector: 'spb-e-pie-chart',
  imports: [NgxEchartsDirective],
  templateUrl: './e-pie-chart.component.html',
  styleUrl: './e-pie-chart.component.scss',
  providers: [
    provideEchartsCore({echarts}),
    {provide: PrintableChartComponent, useExisting: EPieChartComponent}
  ]
})
export class EPieChartComponent extends PrintableChartComponent implements OnChanges {

  public kalp = input.required<KalpResult>()

  public option: EChartsOption = {
    tooltip: {
      trigger: 'item',
      valueFormatter: (v: any) => `${v.toLocaleString('sv-SE', {maximumFractionDigits: 0})} kr/månad`
    },
    series: [
      {
        type: 'pie',
        radius: ['10%', '90%'],
        label: {
          show: false
        },
        data: []
      }
    ],
    grid: {
      width: '10px',
      height: '10px'
    }
  }

  public myChart!: EChartsType

  public chartInit(e: EChartsType) {
    this.myChart = e
  }

  public override print(): string {
    return this.myChart.getDataURL({
      pixelRatio: 2,
      backgroundColor: '#fff'
    })
  }

  public ngOnChanges() {
    const option: any = this.option
    const negative = this.kalp().kalp < 0
    option.series[0]!.data = [
      {
        value: negative ? this.kalp().kalp * -1 : this.kalp().kalp,
        name: 'Överskott/Underskott',
        itemStyle: {color: negative ? '#be0005' : '#008307'}
      },
      {
        value: this.kalp().totalIncome,
        name: 'Inkomster',
        itemStyle: {color: '#7c9ed3'}
      },
      {
        value: this.kalp().totalCost,
        name: 'Kostnader',
        itemStyle: {color: '#fedd46'}
      }
    ]
    this.option = {...this.option}
  }
}
